import loadable from '@loadable/component'

import { Form } from '@tribeplatform/react-sdk/components'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { List } from '@tribeplatform/react-ui-kit/Layout'
import { useSlateComponent } from '@tribeplatform/slate-kit/hooks'

import { useTiptap } from '../../TipTap/hooks/useTiptap'
import { TiptapProvider } from '../../TipTap/TiptapProvider'

const Tiptap = loadable(() => import('../../TipTap'), {
  resolveComponent: module => module.Tiptap,
  ssr: false,
})

const Editor = () => {
  const { upsertProp } = useSlateComponent()
  const { editor } = useTiptap()

  const content = editor?.getHTML()

  useEffect(() => {
    upsertProp('primaryMessage', content)

    // upsertProp changes on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content])

  return <Tiptap />
}

export const SignUpSettings = () => {
  const { component } = useSlateComponent()
  // const secondaryQuillRef = useRef<ComposerRefImperativeHandle>(null)
  const { props } = component

  return (
    <Form defaultValues={props}>
      <List>
        <List.Item>
          <FormControl>
            <FormControl.Label>Sign up Message</FormControl.Label>
            <TiptapProvider content={props?.primaryMessage}>
              <Editor />
            </TiptapProvider>
          </FormControl>
        </List.Item>
        {/* <List.Item>
          <FormControl>
            <FormControl.Label>Secondary Message</FormControl.Label>
            <div className="relative shadow-sm border rounded-md p-3 my-4 border-surface-200/50 overflow-y-auto">
              <Composer
                ref={secondaryQuillRef}
                value={props?.secondaryMessage}
                onChange={value => {
                  upsertProp('secondaryMessage', value)
                }}
              />
            </div>
          </FormControl>
        </List.Item> */}
      </List>
    </Form>
  )
}
